import React, {useEffect, useState} from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './index.module.scss'
import { handleInputChange, extractFormboxLabels, formatInputValue, validateFields } from './utils.jsx' 

import ListGroup from 'react-bootstrap/ListGroup'
import FormField from '../../molecules/FormField'

const Formbox = ({house, fields, onFormChange}) => {
  const [data, setData] = useState(fields);
  const [labelTexts, setFormboxLabels] = useState([]);
  const [value, setValue] = useState({});
  const codeCRC = "CRC"
  var hasCRC = true;

  useEffect(() => { extractFormboxLabels(setFormboxLabels, data); }, [data]);

  return (
    <>
      <h3 className={styles.HouseNum}>HOUSE Nº: {house.houseNum}\{house.year} - CdRefGiant: {house.cdRefGiant}</h3>
      <div className={styles.Formbox}>
        <table className="table table-striped">
          <thead>
            <tr>
              <th scope="col" className={styles.HeadCol}><FormattedMessage id='formBoxStep' defaultMessage="Step"/></th>
              <th scope="col" className={styles.HeadCol}><FormattedMessage id='formBoxDate' defaultMessage="Date"/></th>
            </tr>
          </thead>
          <tbody>
            {validateFields(data).fields.map((formField) => (<FormField
              key={formField.id}
              labelText={formField.labelText}
              index={formField.id}
              inputValue={value[formField.id] !== undefined ? value[formField.id] : formatInputValue(formField.inputValue)}
              onChange={(event) => handleInputChange(setValue, data, setData, onFormChange, formField.labelText, event, formField.id)}
              inputEditable={formField.inputEditable}
              isInvalid={formField.isInvalid}
            />))}
          </tbody>
        </table>
      </div>

      <div className={styles.Progressbox}>
        <h3 className={styles.ProgressH3}><FormattedMessage id='progressH3' defaultMessage="Progress"/></h3>
        <ListGroup horizontal className={styles.Ul}>
          {labelTexts.map((item, index) => {
            if(data.fields[index].labelText.startsWith(codeCRC) && !item) {
              hasCRC = false;
              return null;
            }
            
            return <ListGroup.Item className={item ? styles.FilledLi : styles.Li} key={index}>{hasCRC ? index+1 : index}</ListGroup.Item>
          })}
        </ListGroup>
      </div>
    </>
  )
}

export default Formbox